
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class SimpleCenteredPage extends Vue {
  @Prop({ default: false }) narrow!: string | boolean;

  @Prop({ default: false }) fullWidth!: string | boolean;

  @Prop({ default: false }) fullHeight!: string | boolean;

  @Prop({ default: false }) padded!: string | boolean;

  @Prop({ default: 'pb-5 pt-3' }) footerClass!: string;
}
